window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.BackgroundLevel01 = function() {
	this.initialize(img.MainAssets_BackgroundLevel01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevel02 = function() {
	this.initialize(img.MainAssets_BackgroundLevel02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevel03 = function() {
	this.initialize(img.MainAssets_BackgroundLevel03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevel04 = function() {
	this.initialize(img.MainAssets_BackgroundLevel04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevel05 = function() {
	this.initialize(img.MainAssets_BackgroundLevel05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevel06 = function() {
	this.initialize(img.MainAssets_BackgroundLevel06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3089,4739);


(lib.BackgroundLevelLonger = function() {
	this.initialize(img.MainAssets_BackgroundLevelLonger);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3090,5339);


(lib.Buoy = function() {
	this.initialize(img.MainAssets_Buoy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,190,298);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.ClipboardIcon = function() {
	this.initialize(img.MainAssets_ClipboardIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,108,139);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.Fish01_1 = function() {
	this.initialize(img.MainAssets_Fish01_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_2 = function() {
	this.initialize(img.MainAssets_Fish01_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_3 = function() {
	this.initialize(img.MainAssets_Fish01_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_4 = function() {
	this.initialize(img.MainAssets_Fish01_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_5 = function() {
	this.initialize(img.MainAssets_Fish01_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_6 = function() {
	this.initialize(img.MainAssets_Fish01_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_7 = function() {
	this.initialize(img.MainAssets_Fish01_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_1 = function() {
	this.initialize(img.MainAssets_Fish02_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_2 = function() {
	this.initialize(img.MainAssets_Fish02_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_3 = function() {
	this.initialize(img.MainAssets_Fish02_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_4 = function() {
	this.initialize(img.MainAssets_Fish02_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_5 = function() {
	this.initialize(img.MainAssets_Fish02_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_6 = function() {
	this.initialize(img.MainAssets_Fish02_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_7 = function() {
	this.initialize(img.MainAssets_Fish02_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_1 = function() {
	this.initialize(img.MainAssets_Fish03_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_2 = function() {
	this.initialize(img.MainAssets_Fish03_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_3 = function() {
	this.initialize(img.MainAssets_Fish03_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_4 = function() {
	this.initialize(img.MainAssets_Fish03_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_5 = function() {
	this.initialize(img.MainAssets_Fish03_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_6 = function() {
	this.initialize(img.MainAssets_Fish03_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_7 = function() {
	this.initialize(img.MainAssets_Fish03_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_1 = function() {
	this.initialize(img.MainAssets_Fish04_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_2 = function() {
	this.initialize(img.MainAssets_Fish04_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_3 = function() {
	this.initialize(img.MainAssets_Fish04_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_4 = function() {
	this.initialize(img.MainAssets_Fish04_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_5 = function() {
	this.initialize(img.MainAssets_Fish04_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_6 = function() {
	this.initialize(img.MainAssets_Fish04_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_7 = function() {
	this.initialize(img.MainAssets_Fish04_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_1 = function() {
	this.initialize(img.MainAssets_Fish05_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_2 = function() {
	this.initialize(img.MainAssets_Fish05_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_3 = function() {
	this.initialize(img.MainAssets_Fish05_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_4 = function() {
	this.initialize(img.MainAssets_Fish05_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_5 = function() {
	this.initialize(img.MainAssets_Fish05_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_6 = function() {
	this.initialize(img.MainAssets_Fish05_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_7 = function() {
	this.initialize(img.MainAssets_Fish05_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_1 = function() {
	this.initialize(img.MainAssets_Fish06_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_2 = function() {
	this.initialize(img.MainAssets_Fish06_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_3 = function() {
	this.initialize(img.MainAssets_Fish06_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_4 = function() {
	this.initialize(img.MainAssets_Fish06_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_5 = function() {
	this.initialize(img.MainAssets_Fish06_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_6 = function() {
	this.initialize(img.MainAssets_Fish06_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_7 = function() {
	this.initialize(img.MainAssets_Fish06_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fishingspot_1 = function() {
	this.initialize(img.MainAssets_Fishingspot_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,383,196);


(lib.FishingSpotBubble = function() {
	this.initialize(img.MainAssets_FishingSpotBubble);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,22);


(lib.FishingSpotDarker = function() {
	this.initialize(img.MainAssets_FishingSpotDarker);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotHighlight = function() {
	this.initialize(img.MainAssets_FishingSpotHighlight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingspotPart01 = function() {
	this.initialize(img.MainAssets_FishingspotPart01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart02 = function() {
	this.initialize(img.MainAssets_FishingSpotPart02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart03 = function() {
	this.initialize(img.MainAssets_FishingSpotPart03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart04 = function() {
	this.initialize(img.MainAssets_FishingSpotPart04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.Overlay1_Observe = function() {
	this.initialize(img.MainAssets_Overlay1_Observe);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2668,4816);


(lib.Overlay2_Fish = function() {
	this.initialize(img.MainAssets_Overlay2_Fish);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,4216);


(lib.Overlay3_Professor = function() {
	this.initialize(img.MainAssets_Overlay3_Professor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,4817);


(lib.Overlay4_Report = function() {
	this.initialize(img.MainAssets_Overlay4_Report);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2668,4817);


(lib.Overlay5_Practice = function() {
	this.initialize(img.MainAssets_Overlay5_Practice);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,5596);


(lib.PopupBG = function() {
	this.initialize(img.MainAssets_PopupBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1123,787);


(lib.PracticeIndicatorBackground = function() {
	this.initialize(img.MainAssets_PracticeIndicatorBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1492,152);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.ProfCorrect = function() {
	this.initialize(img.MainAssets_ProfCorrect);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1469,1344);


(lib.ProfessorRod = function() {
	this.initialize(img.MainAssets_ProfessorRod);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2277,2084);


(lib.ProfIncorrect = function() {
	this.initialize(img.MainAssets_ProfIncorrect);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1420,1344);


(lib.ProfNeutral_Closed = function() {
	this.initialize(img.MainAssets_ProfNeutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1071,1344);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.speech_balloon_triangle1 = function() {
	this.initialize(img.MainAssets_speech_balloon_triangle1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,42);


(lib.Splashscreen = function() {
	this.initialize(img.MainAssets_Splashscreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,6188);


(lib.Textballoon_Small1 = function() {
	this.initialize(img.MainAssets_Textballoon_Small1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,675,199);


(lib.TopbarHUD = function() {
	this.initialize(img.MainAssets_TopbarHUD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,159);


(lib.UndoButton = function() {
	this.initialize(img.MainAssets_UndoButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,141,141);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.UndoButtonIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.UndoButton();
	this.instance.setTransform(0,0,0.2838,0.2837);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UndoButtonIcon, new cjs.Rectangle(0,0,40,40), null);


(lib.TextBalloon2Slice9Panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// shortRuleLabelTextField
	this.shortRuleLabelTextField = new cjs.Text("Observing...Observing.\nObserving...Observing.\nObserving...Observing.", "40px 'Roboto'", "#333333");
	this.shortRuleLabelTextField.name = "shortRuleLabelTextField";
	this.shortRuleLabelTextField.lineHeight = 48;
	this.shortRuleLabelTextField.lineWidth = 413;
	this.shortRuleLabelTextField.parent = this;
	this.shortRuleLabelTextField.setTransform(-312.95,-73.25);
ranj.TextOffsetFixer.fix(this.shortRuleLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.shortRuleLabelTextField).wait(1));

	// ruleLabelTextField
	this.ruleLabelTextField = new cjs.Text("Observing...Observing...Observing..\nObserving...Observing...Observing..\nObserving...Observing...Observing..", "40px 'Roboto'", "#333333");
	this.ruleLabelTextField.name = "ruleLabelTextField";
	this.ruleLabelTextField.lineHeight = 48;
	this.ruleLabelTextField.lineWidth = 626;
	this.ruleLabelTextField.parent = this;
	this.ruleLabelTextField.setTransform(-312.95,-73.25);
ranj.TextOffsetFixer.fix(this.ruleLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.ruleLabelTextField).wait(1));

	// Textballoon_Small.png
	this.instance = new lib.Textballoon_Small1();
	this.instance.setTransform(-337.5,-99.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextBalloon2Slice9Panel, new cjs.Rectangle(-337.5,-99.5,675,199), null);


(lib.SelectionPulse = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotHighlight();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SelectionPulse, new cjs.Rectangle(-105,-105,210,210), null);


(lib.Professor01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {neutral:0,open:1,correct:2,incorrect:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// images
	this.instance = new lib.ProfNeutral_Closed();
	this.instance.setTransform(-86.45,-335.35,0.2492,0.2493);

	this.instance_1 = new lib.ProfCorrect();
	this.instance_1.setTransform(-185.45,-335.35,0.2492,0.2493);

	this.instance_2 = new lib.ProfIncorrect();
	this.instance_2.setTransform(-173.45,-335.35,0.2492,0.2493);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-185.4,-335.3,366.1,335);


(lib.hitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApPDQQhWAAg9g+Qg9g8AAhWQAAhVA9g9QA9g9BWABISfAAQBWgBA9A9QA9A9AABVQAABWg9A8Qg9A+hWAAg");
	this.shape.setTransform(79.9796,20.75,1.0003,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.hitArea, new cjs.Rectangle(0,0,160,41.5), null);


(lib.Floaty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.numberTextfield = new cjs.Text("1", "40px 'Roboto'", "#FFFFFF");
	this.numberTextfield.name = "numberTextfield";
	this.numberTextfield.lineHeight = 58;
	this.numberTextfield.lineWidth = 22;
	this.numberTextfield.parent = this;
	this.numberTextfield.setTransform(-11.45,-29.952);
ranj.TextOffsetFixer.fix(this.numberTextfield);

	this.instance = new lib.Buoy();
	this.instance.setTransform(-49.35,-104.45,0.5263,0.5264);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.numberTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Floaty, new cjs.Rectangle(-49.3,-104.4,100,156.8), null);


(lib.FishingSpot_pt4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart04();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt4, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart03();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt3, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart02();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt2, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingspotPart01();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt1, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_Bubble = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotBubble();
	this.instance.setTransform(-10.75,-5.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_Bubble, new cjs.Rectangle(-10.7,-5.5,21.5,11), null);


(lib.FishPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishPlaceholder, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// white
	this.instance = new lib.Fish04_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.EmptyHudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopbarHUD();
	this.instance.setTransform(0,178.8,1.1244,1.1245,0,180,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptyHudBottom, new cjs.Rectangle(0,0,1500,178.8), null);


(lib.DarkPulse = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotDarker();
	this.instance.setTransform(-105,-112,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DarkPulse, new cjs.Rectangle(-105,-112,210,210), null);


(lib.LevelPrepareOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instructionLabel = new cjs.Text("xObserve the fish!", "130px 'Roboto Medium'", "#FFFFFF");
	this.instructionLabel.name = "instructionLabel";
	this.instructionLabel.textAlign = "center";
	this.instructionLabel.lineHeight = 156;
	this.instructionLabel.lineWidth = 978;
	this.instructionLabel.parent = this;
	this.instructionLabel.setTransform(2,-173.75);
ranj.TextOffsetFixer.fix(this.instructionLabel);

	this.timeline.addTween(cjs.Tween.get(this.instructionLabel).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(58,58,58,0.498)").s().p("EhoSDBcMAAAmC3MDQlAAAMAAAGC3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPrepareOverlaySkin, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.TutorialLines5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EA52AOnMhzrAAAIAA9NIbuAA");
	this.shape.setTransform(-78.8,-265.725);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines5, new cjs.Rectangle(-450,-360.2,742.4,189), null);


(lib.TutorialLines4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EBHDht6MiOFAAAMAAADb0");
	this.shape.setTransform(6.975,530.65);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines4, new cjs.Rectangle(-448.7,-173.8,911.4,1408.8999999999999), null);


(lib.TutorialLines3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.TutorialLines2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhD9g2fMCH6AAAMAABBs/");
	this.shape.setTransform(0,-268.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines2, new cjs.Rectangle(-436,-618.4,872,699.5), null);


(lib.TutorialLines1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EA6ggyXMh0/AAAMAAABkv");
	this.shape.setTransform(-75.275,-318.35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines1, new cjs.Rectangle(-450.6,-641.7,750.7,646.7), null);


(lib.TutorialGameBackground4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.numberTextfield = new cjs.Text("1", "40px 'Roboto'", "#FFFFFF");
	this.numberTextfield.name = "numberTextfield";
	this.numberTextfield.lineHeight = 58;
	this.numberTextfield.lineWidth = 22;
	this.numberTextfield.parent = this;
	this.numberTextfield.setTransform(386.8,217.398);
ranj.TextOffsetFixer.fix(this.numberTextfield);

	this.instance = new lib.Buoy();
	this.instance.setTransform(348.9,142.9,0.5263,0.5264);

	this.instance_1 = new lib.Fishingspot_1();
	this.instance_1.setTransform(171.35,264.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.numberTextfield}]}).wait(1));

	// bg
	this.instance_2 = new lib.BackgroundLevelLonger();
	this.instance_2.setTransform(-667.45,-1158,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground4, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialGameBackground2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg
	this.instance = new lib.BackgroundLevelLonger();
	this.instance.setTransform(-667.45,-1158,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground2, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialGameBackground1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.instance = new lib.Fish03_3();
	this.instance.setTransform(155.5,86.85,0.5,0.5);

	this.instance_1 = new lib.Fishingspot_1();
	this.instance_1.setTransform(171.35,264.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.instance_2 = new lib.BackgroundLevelLonger();
	this.instance_2.setTransform(-667.45,-1158,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground1, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundTime = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Overlay2_Fish();
	this.instance.setTransform(-650.3,-1079.9,0.5077,0.5076);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundTime, new cjs.Rectangle(-650.3,-1079.9,1354,2140.2), null);


(lib.TutorialBackgroundPractice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.instance = new lib.Overlay5_Practice();
	this.instance.setTransform(-781,-1310.05,0.5857,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundPractice, new cjs.Rectangle(-781,-1310,1562,2797.3), null);


(lib.TutorialBackgroundNext = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAAAgitMAAABFb");
	this.shape.setTransform(440.3,-48.125);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// cutout BITMAPS
	this.instance = new lib.Overlay3_Professor();
	this.instance.setTransform(-667.5,-1259.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundNext, new cjs.Rectangle(-667.5,-1259.7,1335,2497.7), null);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EgqyghLMAAABCXMBVlAAA");
	this.shape.setTransform(-170.375,-1.175);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// cutout BITMAPS
	this.instance = new lib.Overlay1_Observe();
	this.instance.setTransform(-683.1,-1203.85,0.5114,0.5114);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundBird, new cjs.Rectangle(-683.1,-1238,1364.5,2497.1), null);


(lib.TutorialBackground2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.instance = new lib.Fish06_1();
	this.instance.setTransform(134.05,246.65,0.6098,0.6093);

	this.instance_1 = new lib.Fish05_1();
	this.instance_1.setTransform(-140.55,246.65,0.6098,0.6093);

	this.instance_2 = new lib.Fish04_1();
	this.instance_2.setTransform(-416.45,246.65,0.6098,0.6093);

	this.instance_3 = new lib.Fish03_1();
	this.instance_3.setTransform(134.05,0,0.6098,0.6093);

	this.instance_4 = new lib.Fish02_1();
	this.instance_4.setTransform(-140.55,0,0.6098,0.6093);

	this.instance_5 = new lib.Fish01_1();
	this.instance_5.setTransform(-416.5,0,0.6098,0.6094);

	this.instance_6 = new lib.Overlay2_Fish();
	this.instance_6.setTransform(-748.25,-1163.1,0.5444,0.5444);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackground2, new cjs.Rectangle(-748.2,-1238,1451.9,2476), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.PracticeIndicatorSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textfield = new cjs.Text("xPractice level", "bold 74px 'Roboto'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 89;
	this.textfield.lineWidth = 1193;
	this.textfield.parent = this;
	this.textfield.setTransform(-49.65,-43.75);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg BITMAPS
	this.instance = new lib.PracticeIndicatorBackground();
	this.instance.setTransform(-796.3,-76.05);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeIndicatorSkin, new cjs.Rectangle(-796.3,-76,1492,152), null);


(lib.GateKeeperOverlayLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.Dot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.LevelPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("[level]", "150px 'Arial'", "#FF0000");
	this.text.textAlign = "center";
	this.text.lineHeight = 162;
	this.text.lineWidth = 610;
	this.text.alpha = 0.80000000;
	this.text.parent = this;
	this.text.setTransform(-21.45,-104.8);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPlaceholder, new cjs.Rectangle(-328.5,-106.8,614.2,268.3), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-11);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-11);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-11);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-11);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-34.6,0.4,0.4323);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-34.85,0.4,0.4323);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-34.6,0.4,0.4323);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-34.85}}]},1).to({state:[{t:this.instance_1,p:{y:-34.4}}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-34.8,173.2,73.9);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 29;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 29;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 29;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 29;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.RevisitTutorialButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Revisit instructions\nRevisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 16;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-17.35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Revisit instructions\nRevisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 16;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-17.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Revisit instructions\nRevisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 16;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-17.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Revisit instructions\nRevisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 16;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-17.35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-89.95,-33.65,0.4157,0.4324);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-90.2,-33.65,0.4168,0.4324);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-90.7,-33.65,0.4191,0.4324);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{scaleX:0.4168,x:-90.2}}]},1).to({state:[{t:this.instance_1,p:{scaleX:0.4191,x:-90.7}}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-90.7,-33.6,181.5,73.5);


(lib.ReportButtonFake = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("[Submit]", "17px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(9.35,-10.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// Icon
	this.instance = new lib.ClipboardIcon();
	this.instance.setTransform(-59,-12.25,0.1762,0.1759);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Button
	this.instance_1 = new lib.Button_up();
	this.instance_1.setTransform(-86.6,-32.3,0.4,0.4171);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ReportButtonFake, new cjs.Rectangle(-86.6,-32.3,173.2,70.9), null);


(lib.ReportButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(10.5,-18.35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(10.5,-18.35);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(10.5,-18.35);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(10.5,-18.35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Icon
	this.instance = new lib.ClipboardIcon();
	this.instance.setTransform(-57.35,-12.85,0.1762,0.1759);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Button
	this.instance_1 = new lib.Button_up();
	this.instance_1.setTransform(-86.6,-32.3,0.4,0.4171);

	this.instance_2 = new lib.Button_down();
	this.instance_2.setTransform(-86.6,-32.55,0.4,0.4199);

	this.instance_3 = new lib.Button_disabled();
	this.instance_3.setTransform(-86.6,-33.55,0.4,0.4317);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2,p:{scaleY:0.4199,y:-32.55}}]},1).to({state:[{t:this.instance_2,p:{scaleY:0.4282,y:-33.25}}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-33.5,173.2,73.4);


(lib.Backgroundwhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#303030").s().p("EhoICksMAAAlJXMDQRAAAMAAAFJXg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Backgroundwhite, new cjs.Rectangle(-666.5,-1054,1333,2108), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.TimerFillIntroduction = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CC421A").s().p("AlXLAIgIAAIAA1/IAIAAIABAAQEeADDKDMQDODOAAEiQAAEkjODOQjKDKkeAEg");
	this.shape.setTransform(47.5269,0.0188,1.35,1.35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AlHLKQmPhqjPlmQAAgBBIgsIZRumQApgWABACQDPFmhtGOQhsGPlmDPQjtCJj+AAQiDAAiHgkg");
	mask.setTransform(6.9879,25.2833);

	// Layer_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CC421A").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_1.setTransform(0.0061,0.0188,1.35,1.35);

	var maskedShapeInstanceList = [this.shape_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer_5
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_2.setTransform(0.0387,0.0573,1.4047,1.4047);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimerFillIntroduction, new cjs.Rectangle(-98.8,-98.8,197.7,197.7), null);


(lib.TimerFill = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CC421A").s().p("AlXLAIgIAAIAA1/IAIAAIABAAQEeADDKDMQDODOAAEiQAAEkjODOQjKDKkeAEg");
	this.shape.setTransform(47.5269,0.0188,1.35,1.35);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CC421A").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_1.setTransform(0.0061,0.0188,1.35,1.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},49).to({state:[{t:this.shape_1}]},51).wait(1));

	// Layer_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AjRLAQkmkkAAmcQAAmcEmkkQElkjGgAAQABAAACBUIABdFQgCAugCAAQmhAAkkkkg");
	var mask_graphics_1 = new cjs.Graphics().p("AGWPkQmfgbkSk3QkSk2AambQAbmbE4kRQE3kQGfAbQABAAgDBUIh2dBQgFAvgDAAIAAAAg");
	var mask_graphics_2 = new cjs.Graphics().p("AE3PhQmcg1j+lIQj+lHA1mYQA1mZFJj8QFHj8GdA1QABAAgJBVIjtc1QgHAugDAAIAAAAg");
	var mask_graphics_3 = new cjs.Graphics().p("ADZPcQmYhPjolXQjplXBPmUQBPmVFYjmQFXjnGZBQQABAAgOBUIljcjQgLAsgCAAIAAAAg");
	var mask_graphics_4 = new cjs.Graphics().p("AB7PWQmRhqjSllQjSllBpmOQBomPFnjQQFljQGSBqQABAAgTBSInYcJQgNAsgDAAIAAAAg");
	var mask_graphics_5 = new cjs.Graphics().p("AAgPNQmLiDi6lyQi6lxCCmIQCCmHFyi4QFyi5GLCDQABABgZBRIpKbmQgQArgCAAIAAAAg");
	var mask_graphics_6 = new cjs.Graphics().p("Ag6PCQmBiciil9Qijl9Cbl+QCbl+F+igQF8ihGCCcQABABgeBPIq5a+QgTApgCAAIgBAAg");
	var mask_graphics_7 = new cjs.Graphics().p("AiSO2Ql3i1iJmHQiJmFCzl0QCzl0GHiHQGGiIF3C0QABABgjBNIsmaOQgWAogCAAIgBAAg");
	var mask_graphics_8 = new cjs.Graphics().p("AjnOnQlrjMhvmPQhxmNDLloQDKloGPhuQGOhuFqDLQABABgnBLIuQZWQgYAngDAAIAAAAg");
	var mask_graphics_9 = new cjs.Graphics().p("Ak6OWQlcjjhWmVQhXmUDilaQDhlaGUhUQGVhVFcDjQABAAgsBJIv3YZQgZAkgDAAIgBAAg");
	var mask_graphics_10 = new cjs.Graphics().p("AmJOEQlNj5g8maQg9mYD4lLQD2lLGZg7QGag6FND4QABABgxBFIxZXVQgcAjgDAAIAAAAg");
	var mask_graphics_11 = new cjs.Graphics().p("AnUNwQk9kOghmdQgjmbEMk7QEMk6GbggQGdggE8ENQABABg1BBIy2WLQgeAhgDAAIAAAAg");
	var mask_graphics_12 = new cjs.Graphics().p("AocNaQkrkhgGmeQgImdEfkpQEgkoGcgGQGegGErEhQAAABg5A+I0OU7QggAegEAAIAAAAg");
	var mask_graphics_13 = new cjs.Graphics().p("ApfNDQkXk0AUmdQASmcEykWQEykWGcAVQGeAVEXEzQABABg+A7I1hTkQgiAcgDAAIgBAAg");
	var mask_graphics_14 = new cjs.Graphics().p("AqdMrQkDlFAumbQAumaFDkCQFDkBGaAvQGbAvEDFFQAAAAhBA3I2vSKQgjAZgDAAIgBAAg");
	var mask_graphics_15 = new cjs.Graphics().p("ArWMSQjulVBJmXQBImXFTjsQFSjsGWBJQGYBJDtFVQABABhFAyI32QqQglAXgEAAIAAAAg");
	var mask_graphics_16 = new cjs.Graphics().p("AsKL4QjYlkBjmRQBimSFhjWQFhjWGRBjQGSBkDXFjQABABhIAtI44PGQglAVgFAAIAAAAg");
	var mask_graphics_17 = new cjs.Graphics().p("As5LcQjAlwB8mKQB7mLFvi/QFui/GJB9QGLB9DAFvQAAABhKApI5zNfQgmASgEAAIgBgBg");
	var mask_graphics_18 = new cjs.Graphics().p("AtjLAQiol8CVmBQCVmCF6ioQF4inGCCWQGCCWCoF7QAAABhMAkI6nLzQgnAPgFAAIgBAAg");
	var mask_graphics_19 = new cjs.Graphics().p("AuHKiQiPmGCtl2QCtl4GEiPQGDiPF3CuQF4CvCPGFQAAABhPAeI7UKFQgmAMgGAAIgBAAg");
	var mask_graphics_20 = new cjs.Graphics().p("AulKDQh3mODGlqQDFlsGMh2QGLh1FrDFQFsDGB2GNQAAABhRAaI76ITQglAKgHAAIgBgBg");
	var mask_graphics_21 = new cjs.Graphics().p("Au+JkQhdmVDdldQDblfGUhcQGRhbFeDcQFeDdBdGTQAAABhSAVI8ZGgQgjAHgJAAIgCgBg");
	var mask_graphics_22 = new cjs.Graphics().p("AvRJEQhCmaDylOQDylQGYhCQGXhCFPDzQFPDyBCGYQAAAChTAPI8vErQggAEgKAAQgCAAAAAAQgBAAgBAAQAAAAgBgBQAAAAAAAAg");
	var mask_graphics_23 = new cjs.Graphics().p("AveIkQgomeEIk9QEGlAGcgoQGagnE/EHQE/EHAoGcQAAABhUAKI8/C1IgjABQgMAAAAgBg");
	var mask_graphics_24 = new cjs.Graphics().p("AvkIDQgOmfEcktQEakuGegNQGcgNEtEbQEuEaANGfQAAABhVAEI9HA9QguAAAAgCg");
	var mask_graphics_25 = new cjs.Graphics().p("AORIEI9Ig7QgugDAAgCQANmfEukaQEukbGcANQGdAOEbEuQEbEsgOGfIggAAIg0AAg");
	var mask_graphics_26 = new cjs.Graphics().p("AOKIfI8/iyQgvgGABgDQAomcE/kGQE/kIGbAoQGbAoEHE/QEHE/goGcIgCAAIhTgFg");
	var mask_graphics_27 = new cjs.Graphics().p("AN+I5I8wkoQgugJAAgDQBDmYFPjyQFQjyGXBCQGYBCDyFQQDyFOhDGZIAAAAQgHAAhNgLg");
	var mask_graphics_28 = new cjs.Graphics().p("ANsJUI8ameQgtgMABgDQBcmTFfjbQFejdGSBcQGTBcDcFfQDcFdhcGUIgBAAQgEAAhPgQg");
	var mask_graphics_29 = new cjs.Graphics().p("ANVJuI78oSQgsgPABgCQB2mNFsjEQFrjGGMB2QGMB2DFFrQDFFrh2GNIAAAAQgEAAhOgVg");
	var mask_graphics_30 = new cjs.Graphics().p("AM4KHI7WqDQgrgRABgCQCPmGF4isQF3iuGDCPQGECPCtF3QCuF3iPGEIAAAAQgDAAhOgag");
	var mask_graphics_31 = new cjs.Graphics().p("AMWKfI6qrxQgqgUABgDQCol7GCiUQGCiVF6CoQF5CnCVGCQCVGAinF7IAAAAQgDAAhMggg");
	var mask_graphics_32 = new cjs.Graphics().p("ALvK3I52tdQgpgXABgCQDAlwGLh7QGJh8FvDAQFvC/B8GKQB8GKjAFvIAAAAQgCAAhKglg");
	var mask_graphics_33 = new cjs.Graphics().p("ALCLOI47vFQgngaABgCQDXljGShhQGRhjFiDXQFhDWBjGRQBiGRjWFiIAAAAQgCAAhJgpg");
	var mask_graphics_34 = new cjs.Graphics().p("AKRLkI36wqQglgcABgCQDtlUGXhIQGXhIFTDtQFTDsBJGWQBIGXjsFUIAAAAQgCAAhGgug");
	var mask_graphics_35 = new cjs.Graphics().p("AJcL4I2zyJQgkgfACgCQEClEGbgtQGaguFEECQFDECAuGaQAvGbkCFDIAAAAQgCAAhCgzg");
	var mask_graphics_36 = new cjs.Graphics().p("AIhMMI1mzlQghggACgCQEWkzGdgTQGcgTEzEWQEyEWAUGcQAUGdkWEyIAAAAQgCAAg/g3g");
	var mask_graphics_37 = new cjs.Graphics().p("AHiMfI0S07QgggjACgBQEqkhGdAIQGcAHEgEqQEgEpgGGcQgHGdkpEgIAAAAQgBAAg8g7g");
	var mask_graphics_38 = new cjs.Graphics().p("AGfMxIy62LQgdglACgCQE7kMGcAiQGbAiEME7QEME7ggGbQghGck7EMIAAAAQgBAAg4g/g");
	var mask_graphics_39 = new cjs.Graphics().p("AFYNCIxd3WQgagnACgBQFLj4GZA9QGYA8D4FLQD3FMg7GYQg7GZlLD3IAAAAQgBAAg0hCg");
	var mask_graphics_40 = new cjs.Graphics().p("AENNSIv74bQgYgpADgBQFajiGVBXQGTBWDiFbQDhFbhVGTQhVGVlaDhIAAAAQgBAAgwhFg");
	var mask_graphics_41 = new cjs.Graphics().p("AC/NgIuU5aQgVgpACgBQFojMGNBxQGOBwDLFpQDLFohvGNQhuGOloDLIAAAAQgCAAgrhIg");
	var mask_graphics_42 = new cjs.Graphics().p("ABvNsIsr6RQgSgrACgBQF1izGECKQGGCJC0F1QC0F0iIGGQiIGGl1CzIAAAAQgBAAgmhLg");
	var mask_graphics_43 = new cjs.Graphics().p("AAcN3Iq97CQgQgsACgBQGAibF7CjQF8CiCcF/QCbF/ihF9QihF8l+CbIAAAAQgCAAghhNg");
	var mask_graphics_44 = new cjs.Graphics().p("Ag4OAIpO7rQgNgtADgBQGIiCFwC6QFxC6CDGJQCCGIi5FyQi4FxmHCCIAAAAQgBABgdhQg");
	var mask_graphics_45 = new cjs.Graphics().p("AiOOHInb8NQgLguADgBQGQhoFjDRQFkDSBpGQQBpGPjQFmQjQFlmOBoIAAAAQgBAAgXhRg");
	var mask_graphics_46 = new cjs.Graphics().p("AjmONIln8pQgHguADAAQGWhPFUDoQFXDoBPGWQBPGVjnFXQjmFXmUBPIAAAAQgBAAgShSg");
	var mask_graphics_47 = new cjs.Graphics().p("Ak/OQIjw87QgFgvADAAQGag1FFD+QFHD9A1GbQA1GZj8FIQj8FHmYA1IAAAAQgBAAgNhUg");
	var mask_graphics_48 = new cjs.Graphics().p("AmZOSIh59HQgBgvADAAQGcgaE0ESQE2ERAbGeQAaGckQE3QkQE3mbAaIAAAAQgBAAgIhVg");
	var mask_graphics_49 = new cjs.Graphics().p("AnyOTIgB9LQACgvACAAQGeAAEhElQEkElAAGeQAAGdkkElQkiElmdAAQgBAAgChVg");
	var mask_graphics_50 = new cjs.Graphics().p("AoQPlQgBAAAEhVIBx9IQAFguADAAQGbAZEQE3QERE2gZGdQgaGdk1ESQkaD7lwAAQgjAAgjgCg");
	var mask_graphics_51 = new cjs.Graphics().p("AovPcQgBAAAJhUIDk8+QAIguACAAQGZAzD9FHQD9FGgzGbQgzGalFD/QkODVlKAAQhCAAhEgJg");
	var mask_graphics_52 = new cjs.Graphics().p("ApNPOQgCgBAOhTIFW8sQAKguADABQGVBMDoFWQDpFVhMGWQhMGXlVDqQkACxkmAAQhfAAhjgSg");
	var mask_graphics_53 = new cjs.Graphics().p("ApsO6QgBgBAThTIHG8TQANgtADABQGQBlDSFjQDTFjhlGRQhlGSliDUQjvCRkGAAQh8AAiAggg");
	var mask_graphics_54 = new cjs.Graphics().p("AqKOgQgBAAAYhSII170QAQgrACAAQGJB+C8FvQC9Fwh9GKQh+GKluC/QjdBzjnAAQiXAAicgyg");
	var mask_graphics_55 = new cjs.Graphics().p("AqnOBQgBAAAdhQIKg7OQATgqACAAQGCCWClF6QCmF7iWGBQiVGCl6CoQjHBZjKAAQizAAi1hHg");
	var mask_graphics_56 = new cjs.Graphics().p("ArENeQgBgBAihOIML6hQAVgpACABQF4CsCNGEQCPGEitF4QitF4mECQQivBBiuAAQjPAAjNhdg");
	var mask_graphics_57 = new cjs.Graphics().p("ArfM1QgBgBAmhMINy5tQAYgpACACQFsDDB2GMQB2GLjEFtQjEFtmLB4QiWAtiSAAQjtAAjhh4g");
	var mask_graphics_58 = new cjs.Graphics().p("Ar6MHQgBgBArhJIPW40QAagnACABQFgDaBcGTQBeGRjaFgQjaFgmRBgQh7Adh2AAQkMAAj0iXg");
	var mask_graphics_59 = new cjs.Graphics().p("AsTLUQgBAAAwhHIQ131QAcglADACQFRDvBEGXQBEGXjvFSQjvFSmWBGQhdAQhZAAQkuAAkEi4g");
	var mask_graphics_60 = new cjs.Graphics().p("AsrKdQgBgBAzhDISS2vQAfgkABACQFCEDArGbQAsGakEFDQkEFCmZAtQg9AHg8AAQlSAAkRjcg");
	var mask_graphics_61 = new cjs.Graphics().p("AtDJhQAAAAA3hAITp1lQAhghACABQExEXARGdQATGbkYEzQkWExmcAUIg3ACQl6AAkdkEg");
	var mask_graphics_62 = new cjs.Graphics().p("AicNPQmegFkfkpQgBAAA8g9IU70VQAjgfACACQEgEpgIGdQgIGckpEgQkkEbmSAAIgPAAg");
	var mask_graphics_63 = new cjs.Graphics().p("AjFM1QmcgfkNk5QgBgBBAg5IWJy/QAkgdACACQENE6giGbQghGbk6EOQkaDxloAAQgpAAgqgDg");
	var mask_graphics_64 = new cjs.Graphics().p("AjwMWQmZg4j5lJQAAgBBCg1IXRxmQAngaABACQD5FJg7GZQg6GYlKD6QkODMlBAAQhIAAhMgLg");
	var mask_graphics_65 = new cjs.Graphics().p("AkbLyQmVhRjklYQgBgBBGgwIYUwIQAogZABACQDkFZhUGUQhTGUlZDlQj+CpkfAAQhmAAhqgWg");
	var mask_graphics_66 = new cjs.Graphics().p("AlHLKQmPhqjPlmQAAgBBIgsIZRumQApgWABACQDPFmhtGOQhsGPlmDPQjtCJj+AAQiDAAiHgkg");
	var mask_graphics_67 = new cjs.Graphics().p("Al0KdQmIiDi4lxQAAgBBLgoIaHtBQArgTABACQC4FyiFGHQiEGHlzC5QjZBsjgAAQieAAijg2g");
	var mask_graphics_68 = new cjs.Graphics().p("AmhJrQl/iaihl8QAAgBBNgjIa3rYQAsgRABACQChF9idF9QicF/l9ChQjDBTjCAAQi7AAi8hMg");
	var mask_graphics_69 = new cjs.Graphics().p("AnOI2Ql1iyiJmEQAAgBBPgeIbhpuQAtgOAAACQCKGGi0FzQi0F0mGCKQirA8imAAQjXAAjThkg");
	var mask_graphics_70 = new cjs.Graphics().p("An7H8QlpjIhxmMQAAgBBRgZIcDoAQAugLABACQBxGOjLFnQjKFomOBxQiQApiKAAQj2AAjniAg");
	var mask_graphics_71 = new cjs.Graphics().p("AooG/QlcjehYmSQgBgBBTgUIcgmRQAugIAAACQBZGUjhFaQjfFbmVBZQhzAZhuAAQkWAAj5ifg");
	var mask_graphics_72 = new cjs.Graphics().p("ApUF/QlOjzhAmXQAAgBBUgPIc1kgQAugFABACQA/GZj1FLQj1FNmZA/QhVAOhQAAQk4AAkJjBg");
	var mask_graphics_73 = new cjs.Graphics().p("AqBE7Qk+kHgmmaQAAgBBUgKIdDiuQAvgCAAACQAmGckJE8QkJE9mcAmQg0AFgyAAQleAAkWjmg");
	var mask_graphics_74 = new cjs.Graphics().p("AqsD1QkukagNmcQAAgBBVgFIdKg7QAvABAAACQANGdkcErQkcEsmeANIgjABQmHAAkgkOg");
	var mask_graphics_75 = new cjs.Graphics().p("AgeIBQmegNkbksQkckrANmdQAAgBBVABIdKA4QAvADAAADQgNGdkuEYQkhEPmHAAIgjgBg");
	var mask_graphics_76 = new cjs.Graphics().p("AhZIbQmcgmkJk9QkIk8AmmbQAAgBBVAGIdDCrQAuAGAAACQgmGbk/EGQkWDmleAAQgyAAg0gFg");
	var mask_graphics_77 = new cjs.Graphics().p("AiSIyQmZg/j0lNQj1lMA/mYQABgBBUALIc1EdQAuAJAAADQhAGXlODyQkJDBk4AAQhRAAhVgNg");
	var mask_graphics_78 = new cjs.Graphics().p("AjIJFQmUhZjglbQjglbBZmTQAAgBBTAQIchGPQAtAMgBACQhYGTldDdQj5CfkWAAQhuAAhzgZg");
	var mask_graphics_79 = new cjs.Graphics().p("Aj8JTQmOhxjKlpQjJlnBwmNQABgBBSAVIcEH+QAtAPgBACQhxGNlqDHQjnCAj1AAQiLAAiQgpg");
	var mask_graphics_80 = new cjs.Graphics().p("AktJeQmGiKizl0Qi0lzCKmGQAAgBBRAbIbhJrQAsASgBACQiJGFl2CxQjSBkjYAAQimAAirg8g");
	var mask_graphics_81 = new cjs.Graphics().p("AlbJkQl9ihicl/Qicl+Chl7QAAgBBPAfIa4LWQArAUgBACQihF9mACZQi7BMi7AAQjDAAjDhTg");
	var mask_graphics_82 = new cjs.Graphics().p("AmGJmQlyi4iEmIQiFmGC4lxQABgBBNAkIaIM+QApAXgBACQi5FymICCQiiA1ifAAQjfAAjahsg");
	var mask_graphics_83 = new cjs.Graphics().p("AmuJkQlmjOhsmPQhsmODPllQAAgBBLAoIZROkQAoAZgBADQjPFlmPBqQiIAjiCAAQj+AAjuiJg");
	var mask_graphics_84 = new cjs.Graphics().p("AnSJfQlZjlhTmUQhTmUDklYQABgBBHAtIYWQGQAmAbgCACQjkFZmVBQQhrAVhmAAQkeAAj/iog");
	var mask_graphics_85 = new cjs.Graphics().p("AnzJUQlKj5g6mYQg6mZD5lJQAAgBBFAxIXTRkQAkAegBACQj5FKmaA3QhLAKhIAAQlCAAkOjMg");
	var mask_graphics_86 = new cjs.Graphics().p("AoQJGQk6kNghmbQggmcEMk5QABgBBCA2IWKS9QAjAggCACQkNE6mcAeQgqADgqAAQlnAAkbjyg");
	var mask_graphics_87 = new cjs.Graphics().p("AopI0QkpkggHmcQgHmeEfkoQABgBA+A6IU9UTQAhAigCABQkgEpmdAFIgPAAQmTAAkkkbg");
	var mask_graphics_88 = new cjs.Graphics().p("AB2NjQmcgUkXkyQkXkyASmcQASmdExkVQABgBA7A9ITqVjQAfAkgCACQkcECl5AAIg5gBg");
	var mask_graphics_89 = new cjs.Graphics().p("ABQNyQmagtkDlDQkElDAsmZQArmbFCkDQAAgBA3BBISUWuQAbAmgCABQkRDclRAAQg8AAg+gHg");
	var mask_graphics_90 = new cjs.Graphics().p("AAsN8QmWhHjwlSQjvlSBFmWQBFmYFRjuQAAgBAzBEIQ4X0QAZAngCABQkDC4ktAAQhaAAhegQg");
	var mask_graphics_91 = new cjs.Graphics().p("AAKOAQmRhfjblhQjZlgBdmRQBemSFfjaQABAAAuBHIPYYzQAXAogCACQj0CXkMAAQh2AAh7geg");
	var mask_graphics_92 = new cjs.Graphics().p("AgWN/QmLh4jEltQjElsB2mLQB2mMFsjDQABgBAqBKIN0ZsQAUAqgCACQjhB4jtAAQiSAAiWgug");
	var mask_graphics_93 = new cjs.Graphics().p("Ag1N5QmDiQitl4Qitl3COmEQCPmEF3isQABgBAlBMIMNagQASArgCACQjMBdjQAAQiuAAiwhCg");
	var mask_graphics_94 = new cjs.Graphics().p("AhRNuQl6ioiWmCQiVmBCml6QCml6GBiWQABAAAgBPIKjbMQAQAsgDABQi1BHizAAQjKAAjHhag");
	var mask_graphics_95 = new cjs.Graphics().p("AhsNeQlvi/h9mLQh+mJC9lvQC9lwGJh9QABAAAbBQII4bzQAMAtgCABQicAyiXAAQjoAAjch0g");
	var mask_graphics_96 = new cjs.Graphics().p("AiFNJQlijVhlmSQhlmQDUljQDTljGPhlQABAAAXBSIHJcSQAJAugCABQiBAgh7AAQkGAAjwiRg");
	var mask_graphics_97 = new cjs.Graphics().p("AibMvQlUjrhMmXQhMmWDolVQDplVGVhMQABAAARBTIFZcrQAHAugDABQhjAShfAAQknAAkAixg");
	var mask_graphics_98 = new cjs.Graphics().p("AivMQQlFj/gzmbQgzmaD+lHQD9lGGYgzQACAAAMBUIDnc9QAEAvgDAAQhEAJhBAAQlLAAkOjVg");
	var mask_graphics_99 = new cjs.Graphics().p("AjALsQk1kTgZmdQgamcERk3QERk2GbgZQABAAAHBUIB0dIQABAvgCAAQgjACgiAAQlyAAkZj7g");
	var mask_graphics_100 = new cjs.Graphics().p("AjPLDQkkklAAmeQAAmdEkklQEiklGdAAQABAAACBVIABdLQgCAvgCAAQmeAAkhklg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-50.2718,y:-0.1}).wait(1).to({graphics:mask_graphics_1,x:-47.2951,y:-0.2451}).wait(1).to({graphics:mask_graphics_2,x:-44.1459,y:-0.6165}).wait(1).to({graphics:mask_graphics_3,x:-41.0189,y:-1.1991}).wait(1).to({graphics:mask_graphics_4,x:-37.922,y:-1.9808}).wait(1).to({graphics:mask_graphics_5,x:-34.8625,y:-2.9514}).wait(1).to({graphics:mask_graphics_6,x:-31.8497,y:-4.1025}).wait(1).to({graphics:mask_graphics_7,x:-28.8947,y:-5.4277}).wait(1).to({graphics:mask_graphics_8,x:-26.0108,y:-6.9222}).wait(1).to({graphics:mask_graphics_9,x:-23.2135,y:-8.5828}).wait(1).to({graphics:mask_graphics_10,x:-20.5202,y:-10.4083}).wait(1).to({graphics:mask_graphics_11,x:-17.9509,y:-12.3996}).wait(1).to({graphics:mask_graphics_12,x:-15.5282,y:-14.5603}).wait(1).to({graphics:mask_graphics_13,x:-13.281,y:-16.894}).wait(1).to({graphics:mask_graphics_14,x:-11.2093,y:-19.3845}).wait(1).to({graphics:mask_graphics_15,x:-9.3058,y:-22.008}).wait(1).to({graphics:mask_graphics_16,x:-7.5683,y:-24.7433}).wait(1).to({graphics:mask_graphics_17,x:-5.9969,y:-27.5722}).wait(1).to({graphics:mask_graphics_18,x:-4.5936,y:-30.4782}).wait(1).to({graphics:mask_graphics_19,x:-3.362,y:-33.4474}).wait(1).to({graphics:mask_graphics_20,x:-2.3076,y:-36.4673}).wait(1).to({graphics:mask_graphics_21,x:-1.4374,y:-39.5275}).wait(1).to({graphics:mask_graphics_22,x:-0.7602,y:-42.6183}).wait(1).to({graphics:mask_graphics_23,x:-0.2867,y:-45.7271}).wait(1).to({graphics:mask_graphics_24,x:-0.0299,y:-48.8062}).wait(1).to({graphics:mask_graphics_25,x:0.0548,y:-48.9082}).wait(1).to({graphics:mask_graphics_26,x:0.3116,y:-45.7555}).wait(1).to({graphics:mask_graphics_27,x:0.7848,y:-42.6101}).wait(1).to({graphics:mask_graphics_28,x:1.461,y:-39.4938}).wait(1).to({graphics:mask_graphics_29,x:2.3292,y:-36.4132}).wait(1).to({graphics:mask_graphics_30,x:3.3804,y:-33.3764}).wait(1).to({graphics:mask_graphics_31,x:4.6074,y:-30.3934}).wait(1).to({graphics:mask_graphics_32,x:6.0046,y:-27.4765}).wait(1).to({graphics:mask_graphics_33,x:7.5682,y:-24.6398}).wait(1).to({graphics:mask_graphics_34,x:9.296,y:-21.8997}).wait(1).to({graphics:mask_graphics_35,x:11.1879,y:-19.2747}).wait(1).to({graphics:mask_graphics_36,x:13.2463,y:-16.786}).wait(1).to({graphics:mask_graphics_37,x:15.476,y:-14.4596}).wait(1).to({graphics:mask_graphics_38,x:17.8743,y:-12.3132}).wait(1).to({graphics:mask_graphics_39,x:20.4184,y:-10.3365}).wait(1).to({graphics:mask_graphics_40,x:23.0859,y:-8.5258}).wait(1).to({graphics:mask_graphics_41,x:25.8573,y:-6.8799}).wait(1).to({graphics:mask_graphics_42,x:28.7155,y:-5.3997}).wait(1).to({graphics:mask_graphics_43,x:31.6452,y:-4.088}).wait(1).to({graphics:mask_graphics_44,x:34.6336,y:-2.9494}).wait(1).to({graphics:mask_graphics_45,x:37.6692,y:-1.9898}).wait(1).to({graphics:mask_graphics_46,x:40.7422,y:-1.217}).wait(1).to({graphics:mask_graphics_47,x:43.8428,y:-0.6405}).wait(1).to({graphics:mask_graphics_48,x:46.951,y:-0.2719}).wait(1).to({graphics:mask_graphics_49,x:49.9989,y:0}).wait(1).to({graphics:mask_graphics_50,x:47.1336,y:0.1344}).wait(1).to({graphics:mask_graphics_51,x:44.1009,y:0.4739}).wait(1).to({graphics:mask_graphics_52,x:41.0924,y:1.0059}).wait(1).to({graphics:mask_graphics_53,x:38.1149,y:1.7197}).wait(1).to({graphics:mask_graphics_54,x:35.1741,y:2.6065}).wait(1).to({graphics:mask_graphics_55,x:32.2776,y:3.6593}).wait(1).to({graphics:mask_graphics_56,x:29.4345,y:4.8722}).wait(1).to({graphics:mask_graphics_57,x:26.6558,y:6.2409}).wait(1).to({graphics:mask_graphics_58,x:23.9544,y:7.7625}).wait(1).to({graphics:mask_graphics_59,x:21.3447,y:9.4357}).wait(1).to({graphics:mask_graphics_60,x:18.8433,y:11.2606}).wait(1).to({graphics:mask_graphics_61,x:16.469,y:13.2398}).wait(1).to({graphics:mask_graphics_62,x:14.2452,y:15.3779}).wait(1).to({graphics:mask_graphics_63,x:12.1868,y:17.6731}).wait(1).to({graphics:mask_graphics_64,x:10.2839,y:20.1052}).wait(1).to({graphics:mask_graphics_65,x:8.5334,y:22.6544}).wait(1).to({graphics:mask_graphics_66,x:6.934,y:25.3029}).wait(1).to({graphics:mask_graphics_67,x:5.4864,y:28.0349}).wait(1).to({graphics:mask_graphics_68,x:4.1929,y:30.8368}).wait(1).to({graphics:mask_graphics_69,x:3.0573,y:33.6964}).wait(1).to({graphics:mask_graphics_70,x:2.0846,y:36.6031}).wait(1).to({graphics:mask_graphics_71,x:1.2814,y:39.5478}).wait(1).to({graphics:mask_graphics_72,x:0.6558,y:42.5218}).wait(1).to({graphics:mask_graphics_73,x:0.2174,y:45.5133}).wait(1).to({graphics:mask_graphics_74,x:-0.022,y:48.4751}).wait(1).to({graphics:mask_graphics_75,x:-0.1034,y:48.5804}).wait(1).to({graphics:mask_graphics_76,x:-0.3421,y:45.5524}).wait(1).to({graphics:mask_graphics_77,x:-0.7793,y:42.5304}).wait(1).to({graphics:mask_graphics_78,x:-1.4034,y:39.5367}).wait(1).to({graphics:mask_graphics_79,x:-2.2047,y:36.5768}).wait(1).to({graphics:mask_graphics_80,x:-3.1753,y:33.6571}).wait(1).to({graphics:mask_graphics_81,x:-4.3087,y:30.786}).wait(1).to({graphics:mask_graphics_82,x:-5.6,y:27.9736}).wait(1).to({graphics:mask_graphics_83,x:-7.0454,y:25.2319}).wait(1).to({graphics:mask_graphics_84,x:-8.6429,y:22.5744}).wait(1).to({graphics:mask_graphics_85,x:-10.3918,y:20.0167}).wait(1).to({graphics:mask_graphics_86,x:-12.2934,y:17.5763}).wait(1).to({graphics:mask_graphics_87,x:-14.3513,y:15.2734}).wait(1).to({graphics:mask_graphics_88,x:-16.5697,y:13.1335}).wait(1).to({graphics:mask_graphics_89,x:-18.936,y:11.1535}).wait(1).to({graphics:mask_graphics_90,x:-21.429,y:9.3271}).wait(1).to({graphics:mask_graphics_91,x:-24.0299,y:7.6521}).wait(1).to({graphics:mask_graphics_92,x:-26.722,y:6.1284}).wait(1).to({graphics:mask_graphics_93,x:-29.4907,y:4.7575}).wait(1).to({graphics:mask_graphics_94,x:-32.3228,y:3.5424}).wait(1).to({graphics:mask_graphics_95,x:-35.2072,y:2.4875}).wait(1).to({graphics:mask_graphics_96,x:-38.134,y:1.5987}).wait(1).to({graphics:mask_graphics_97,x:-41.0944,y:0.8831}).wait(1).to({graphics:mask_graphics_98,x:-44.0792,y:0.3498}).wait(1).to({graphics:mask_graphics_99,x:-47.0686,y:0.0093}).wait(1).to({graphics:mask_graphics_100,x:-49.9989,y:0}).wait(1));

	// Layer_2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#CC421A").s().p("AnUO0IgLAAIAA9nIALAAIABAAQGGAEEUESQEZEVAAGIQAAGJkZEVQkUERmGAFg");
	this.shape_2.setTransform(48,0);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#CC421A").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_3.setTransform(0.0061,0.0188,1.35,1.35);

	var maskedShapeInstanceList = [this.shape_2,this.shape_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2}]}).to({state:[{t:this.shape_3}]},49).wait(52));

	// Layer_5
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("Aq7K7QkgkhgBmaQABmYEgkiQEjkhGYgBQGaABEhEhQEiEiAAGYQAAGakiEhQkhEimaAAQmYAAkjkig");
	this.shape_4.setTransform(0.05,0.05);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(101));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-98.8,-98.8,197.7,197.7);


(lib.SelectionPulseAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SelectionPulse();
	this.instance.setTransform(0,0,0.6905,0.6905);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1},59).to({scaleX:0.6905,scaleY:0.6905},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-105,210,210);


(lib.FloatyAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_14 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(14).call(this.frame_14).wait(1));

	// Layer_1
	this.selectIndicator = new lib.Floaty();
	this.selectIndicator.name = "selectIndicator";
	this.selectIndicator.setTransform(0,-104.5);
	this.selectIndicator.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.selectIndicator).to({y:11.35,alpha:1},9).to({y:0},5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-49.3,-208.9,100,272.7);


(lib.FishingSpotAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Pt2 copy
	this.instance = new lib.FishingSpot_pt2();
	this.instance.setTransform(0,0,0.4191,0.4191);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(114).to({_off:false},0).to({scaleX:0.5569,scaleY:0.5569,alpha:1},35).wait(1));

	// Pt1 copy
	this.instance_1 = new lib.FishingSpot_pt1();
	this.instance_1.setTransform(0,0,0.7143,0.7143);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(114).to({_off:false},0).to({scaleX:0.782,scaleY:0.782,alpha:1},35).wait(1));

	// Bubbles copy
	this.instance_2 = new lib.FishingSpot_Bubble();
	this.instance_2.setTransform(0,0,0.5581,0.5546);
	this.instance_2.alpha = 0;
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(114).to({_off:false},0).to({scaleX:0.663,scaleY:0.6602,x:-0.05,y:0.1,alpha:1},35).wait(1));

	// Pt4 copy
	this.instance_3 = new lib.FishingSpot_pt4();
	this.instance_3.setTransform(-0.1,-0.1,0.87,0.87,0,0,0,-0.4,-0.4);
	this.instance_3.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0,alpha:0},35).wait(115));

	// Pt3 copy
	this.instance_4 = new lib.FishingSpot_pt3();
	this.instance_4.setTransform(-0.1,-0.1,0.8395,0.8395,0,0,0,-0.6,-0.6);
	this.instance_4.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0,alpha:0},35).wait(115));

	// Bubbles2 copy
	this.instance_5 = new lib.FishingSpot_Bubble();
	this.instance_5.setTransform(-0.25,0.45,0.8951,0.8943);
	this.instance_5.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({scaleX:1,scaleY:1,y:0.5,alpha:0},35).wait(115));

	// Pt4
	this.instance_6 = new lib.FishingSpot_pt4();
	this.instance_6.setTransform(-0.25,-0.25,0.4523,0.4523,0,0,0,-0.5,-0.5);
	this.instance_6.alpha = 0;
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(57).to({_off:false},0).to({regX:-0.4,regY:-0.4,scaleX:0.5916,scaleY:0.5916,x:-0.15,y:-0.15,alpha:1},32).to({scaleX:0.87,scaleY:0.87,x:-0.1,y:-0.1,alpha:0.3203},60).wait(1));

	// Pt3
	this.instance_7 = new lib.FishingSpot_pt3();
	this.instance_7.setTransform(-0.2,-0.2,0.3238,0.3238,0,0,0,-0.6,-0.6);
	this.instance_7.alpha = 0;
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(57).to({_off:false},0).to({scaleX:0.4957,scaleY:0.4957,alpha:1},32).to({scaleX:0.8395,scaleY:0.8395,x:-0.1,y:-0.1,alpha:0.3203},60).wait(1));

	// Bubbles2
	this.instance_8 = new lib.FishingSpot_Bubble();
	this.instance_8.setTransform(0,0,0.5581,0.5546);
	this.instance_8.alpha = 0;
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(57).to({_off:false},0).to({scaleX:0.6705,scaleY:0.6678,x:-0.05,y:0.15,alpha:1},32).to({scaleX:0.8951,scaleY:0.8943,x:-0.25,y:0.45,alpha:0.3203},60).wait(1));

	// Pt2
	this.instance_9 = new lib.FishingSpot_pt2();
	this.instance_9.setTransform(0,0,0.5569,0.5569);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({scaleX:1,scaleY:1,alpha:0},79).wait(71));

	// Pt1
	this.instance_10 = new lib.FishingSpot_pt1();
	this.instance_10.setTransform(0,0,0.782,0.782);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({scaleX:1,scaleY:1,alpha:0},79).wait(71));

	// Bubbles
	this.instance_11 = new lib.FishingSpot_Bubble();
	this.instance_11.setTransform(-0.05,0.1,0.663,0.6602);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).to({scaleX:1,scaleY:1,x:-0.25,y:0.5,alpha:0},79).wait(71));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-105,210.1,210.1);


(lib.DarkPulseAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DarkPulse();
	this.instance.setTransform(0,0,0.6905,0.6905);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1},59).to({scaleX:0.6905,scaleY:0.6905},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-112,210,210);


(lib.GenericPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.bodyTextfield = new cjs.Text("bodyTextfield\nLine2", "40px 'Roboto Medium'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 59;
	this.bodyTextfield.lineWidth = 866;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-435.55,-196.3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("titleTextfield", "50px 'Roboto Medium'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 67;
	this.titleTextfield.lineWidth = 866;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-435.55,-290.6);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(1));

	// Buttons
	this.cancelButton = new lib.StartGameButton_Overlay();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(236.3,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.continueButton = new lib.StartGameButton_Overlay();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-232.2,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.cancelButton}]}).wait(1));

	// PopupBG
	this.instance = new lib.PopupBG();
	this.instance.setTransform(-561.5,-393.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(58,58,58,0.498)").s().p("EhoSDBcMAAAmC3MDQlAAAMAAAGC3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GenericPopup, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.GateKeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttons
	this.button2 = new lib.StartGameButton_Overlay();
	this.button2.name = "button2";
	this.button2.setTransform(259.8,540.2,2.7273,2.7273);

	this.button1 = new lib.RevisitTutorialButton();
	this.button1.name = "button1";
	this.button1.setTransform(-238.35,540.2,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.button1},{t:this.button2}]}).wait(1));

	// lines
	this.lines = new lib.GateKeeperOverlayLines();
	this.lines.name = "lines";
	this.lines.setTransform(-34.45,-587);

	this.timeline.addTween(cjs.Tween.get(this.lines).wait(1));

	// Titles
	this.titleTextfield = new cjs.Text("xGatekeeper", "20px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 16;
	this.titleTextfield.lineWidth = 283;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-590.8,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Text
	this.bodyTextfield = new cjs.Text("• xYou control the red racing car\nline2", "14px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 17;
	this.bodyTextfield.lineWidth = 267;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-423.5,-473.05,3,3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// bg
	this.bg = new lib.TutorialBackgroundTime();
	this.bg.name = "bg";
	this.bg.setTransform(-26.6,6,1.1092,1);
	this.bg.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlaySkin, new cjs.Rectangle(-747.9,-1180.2,1831.3000000000002,2300.5), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// title
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 58;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-585.752);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// text
	this.titleTextfield = new cjs.Text("Minigame", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-789.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(0,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// img
	this.instance = new lib.ProfessorRod();
	this.instance.setTransform(379.25,62,0.2846,0.2854,0,0,180);

	this.instance_1 = new lib.Splashscreen();
	this.instance_1.setTransform(-667,-1232,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Background
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,3148), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	// Layer_4
	this.instance_1 = new lib.Dot("synched",0);
	this.instance_1.setTransform(0,0,0.6451,0.6451);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// practice indicator
	this.practiceIndicator = new lib.PracticeIndicatorSkin();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(13.9,-7.15,0.2999,0.2999);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-224.8,-29.9,447.3,45.5), null);


(lib.FishPlaceholder_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// circle
	this.instance_1 = new lib.Fish1E();
	this.instance_1.setTransform(-0.65,-113.65,1.3304,1.3304,0,0,0,-0.3,-113.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishPlaceholder_1, new cjs.Rectangle(-150.6,-263.7,300,300), null);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.UndoButton2Fake = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("[Undo]", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 87;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-43.25,-10.5);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// Button
	this.instance = new lib.UndoButtonIcon();
	this.instance.setTransform(-67.95,-0.1,0.875,0.875,0,0,0,20,20);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hitarea
	this.hitarea = new lib.hitArea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(-4.05,-0.2,1,1,0,0,0,59.2,20.8);
	this.hitarea.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UndoButton2Fake, new cjs.Rectangle(-85.4,-21,182.2,41.5), null);


(lib.UndoButton2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 84;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-16,-21);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 84;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-16,-21);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 84;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-16,-21);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start\nStart", "17px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 84;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-16,-21);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.icon = new lib.UndoButtonIcon();
	this.icon.name = "icon";
	this.icon.setTransform(-38.7,-0.5,0.875,0.875,0,0,0,20,20);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(3).to({alpha:0.5},0).wait(1));

	// hitarea
	this.hitarea = new lib.hitArea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(-4.05,-0.2,1,1,0,0,0,59.2,20.8);
	this.hitarea.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-63.2,-23,160,48.8);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 18;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 18;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 18;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 18;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 18;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 18;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 18;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 18;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.TimerIntroduction = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Fill
	this.TimerFill = new lib.TimerFillIntroduction();
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(-75.4,0,1,1,0,0,0,-81,0);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimerIntroduction, new cjs.Rectangle(-93.2,-98.8,235.39999999999998,235.39999999999998), null);


(lib.Timer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Fill
	this.TimerFill = new lib.TimerFill();
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(-75.4,0,1,1,0,0,0,-81,0);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Timer, new cjs.Rectangle(-95.1,-99.7,199.6,199.3), null);


(lib.TutorialHUDButtons = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EgD7gwBMAAABgDIH3AA");
	this.shape.setTransform(-11.025,-229.65);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhE/AL6QhzAAhRhJQhRhJAAhoIAAv/QAAhoBRhJQBRhJBzAAMCNMAAAQBzAABRBJQBSBJAABoIAAP/QAABohSBJQhRBJhzAAg");
	mask.setTransform(489.8763,76.225);

	// Buttons
	this.instance = new lib.TimerIntroduction();
	this.instance.setTransform(88.55,81.05,0.5167,0.5222,0,0,0,1.9,4.8);

	this.buttonClear = new lib.UndoButton2Fake();
	this.buttonClear.name = "buttonClear";
	this.buttonClear.setTransform(869.05,81.6,2.2225,2.2036,0,0,0,-0.4,0.7);

	this.buttonSubmit = new lib.ReportButtonFake();
	this.buttonSubmit.name = "buttonSubmit";
	this.buttonSubmit.setTransform(462.9,81.6,2.5783,2.5565,0,0,0,1.9,0.7);

	this.instance_1 = new lib.TopbarHUD();
	this.instance_1.setTransform(-313.45,165.1,1.1244,1.1245,0,180,0);

	var maskedShapeInstanceList = [this.instance,this.buttonClear,this.buttonSubmit,this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.buttonSubmit},{t:this.buttonClear},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialHUDButtons, new cjs.Rectangle(-37.2,-538,1017,690.5), null);


(lib.Textballoon2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {normal:0,"correct":1,"incorrect":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fish
	this.fish = new lib.FishPlaceholder_1();
	this.fish.name = "fish";
	this.fish.setTransform(225.95,77.65,0.9334,0.9333,0,0,0,-0.6,-30.5);

	this.timeline.addTween(cjs.Tween.get(this.fish).wait(3));

	// slicedPanel
	this.slicedPanel = new lib.TextBalloon2Slice9Panel();
	this.slicedPanel.name = "slicedPanel";
	this.slicedPanel.setTransform(1.45,0);

	this.timeline.addTween(cjs.Tween.get(this.slicedPanel).wait(3));

	// speech_balloon_triangle.png
	this.instance = new lib.speech_balloon_triangle1();
	this.instance.setTransform(-383.45,-74.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-383.4,-140,749.4,280);


(lib.PuddleButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// floaty
	this.selectIndicator = new lib.FloatyAnimation();
	this.selectIndicator.name = "selectIndicator";
	this.selectIndicator.setTransform(170.9,-19.8);
	this.selectIndicator._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectIndicator).wait(6).to({_off:false},0).wait(2));

	// splashes
	this.instance = new lib.FishingSpotAnimation();
	this.instance.setTransform(48.75,37);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({alpha:0.5},0).wait(1).to({alpha:1},0).wait(4));

	// state highlight
	this.instance_1 = new lib.SelectionPulseAnimation();
	this.instance_1.setTransform(49,37);

	this.instance_2 = new lib.DarkPulseAnimation();
	this.instance_2.setTransform(49,37);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.3,-228.7,263.9,357.29999999999995);


(lib.Hotspot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fishSlot
	this.fish = new lib.FishPlaceholder();
	this.fish.name = "fish";
	this.fish.setTransform(106.05,97,1,1,0,0,0,106.5,52.5);

	this.timeline.addTween(cjs.Tween.get(this.fish).wait(1));

	// puddle
	this.puddleButton = new lib.PuddleButton();
	this.puddleButton.name = "puddleButton";
	this.puddleButton.setTransform(-0.45,39,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get(this.puddleButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hotspot, new cjs.Rectangle(-113.4,-181.5,225.5,310.1), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 54;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.TutorialGameBackground5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(2.85,-791.9,3,3);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// bg
	this.instance = new lib.BackgroundLevelLonger();
	this.instance.setTransform(-667.45,-1158,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground5, new cjs.Rectangle(-671.7,-1238,1342.1,2476), null);


(lib.TutorialGameBackground3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.textballoon = new lib.Textballoon2();
	this.textballoon.name = "textballoon";
	this.textballoon.setTransform(120.6,333.4);

	this.instance = new lib.ProfNeutral_Closed();
	this.instance.setTransform(-276.45,138.1,0.2495,0.2495,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.textballoon}]}).wait(1));

	// bg
	this.instance_1 = new lib.BackgroundLevelLonger();
	this.instance_1.setTransform(-667.45,-1158,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground3, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialBackground4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// LineMid
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAzWgAFMhmrAAL");
	this.shape.setTransform(-153.075,223.975);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// TutorialHUDButtons
	this.tutButtons = new lib.TutorialHUDButtons();
	this.tutButtons.name = "tutButtons";
	this.tutButtons.setTransform(-12.55,793.9,1,1,0,0,0,433.4,77.2);

	this.timeline.addTween(cjs.Tween.get(this.tutButtons).wait(1));

	// cutout BITMAPS
	this.instance = new lib.Overlay4_Report();
	this.instance.setTransform(-666.15,-1186.25,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackground4, new cjs.Rectangle(-759.4,-1238,1500,2476), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot6 = new lib.ProgressDot_1();
	this.dot6.name = "dot6";
	this.dot6.setTransform(144,0);

	this.dot0 = new lib.ProgressDot_1();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-144,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-96,0);

	this.dot5 = new lib.ProgressDot_1();
	this.dot5.name = "dot5";
	this.dot5.setTransform(96,0);

	this.dot4 = new lib.ProgressDot_1();
	this.dot4.name = "dot4";
	this.dot4.setTransform(48,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-48,0);

	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot3},{t:this.dot2},{t:this.dot4},{t:this.dot5},{t:this.dot1},{t:this.dot0},{t:this.dot6}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-159,-15,318,30), null);


(lib.HudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Timer
	this.Timer = new lib.Timer();
	this.Timer.name = "Timer";
	this.Timer.setTransform(-126.85,-1.25,0.1769,0.1748,0,0,0,2.2,4.3);

	this.timeline.addTween(cjs.Tween.get(this.Timer).wait(1));

	// Layer_2
	this.buttonNext = new lib.StartGameButton();
	this.buttonNext.name = "buttonNext";
	this.buttonNext.setTransform(-0.15,0.9,0.85,0.85,0,0,0,-0.2,3);

	this.timeline.addTween(cjs.Tween.get(this.buttonNext).wait(1));

	// Layer_4
	this.buttonClear = new lib.UndoButton2();
	this.buttonClear.name = "buttonClear";
	this.buttonClear.setTransform(122.65,-2.8,0.8082,0.8065,0,0,0,0.7,-0.6);

	this.buttonSubmit = new lib.ReportButton();
	this.buttonSubmit.name = "buttonSubmit";
	this.buttonSubmit.setTransform(0.55,-1.75,0.8082,0.8065,0,0,0,0.7,-0.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.buttonSubmit},{t:this.buttonClear}]}).wait(1));

	// text short
	this.text = new cjs.Text("", "14px 'Roboto-Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 17;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// text
	this.text_1 = new cjs.Text("", "14px 'Roboto-Medium'", "#FFFFFF");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 17;
	this.text_1.lineWidth = 100;
	this.text_1.parent = this;
	this.text_1.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// bg
	this.instance = new lib.TopbarHUD();
	this.instance.setTransform(-255,28.6,0.3748,0.3749,0,180,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBottom, new cjs.Rectangle(-255,-31,500,60.9), null);


(lib.Pond6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,675.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(382.3,336.25,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(366.3,-354.6,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-141.55,212.05,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-240.75,-366.8,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-318.65,-6.75,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(170.45,163.05,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(235.8,-582.95,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel05();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond6, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Pond5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,675.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(70.95,-168.75,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(78.75,193.1,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-240.75,-366.8,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-254.1,55.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(381.2,331,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(381.2,-37.5,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel06();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond5, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Pond4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,675.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(364.75,61.7,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-135.9,143.85,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(203.2,347.1,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-308.5,-116.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(101.4,-143.55,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(271.2,-401.1,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel04();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond4, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Pond3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,675.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(197.6,-239.15,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(348,16.65,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(411.3,346.75,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(87.65,291.8,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(-308.5,-100.3,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(-27.9,-482.35,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel03();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond3, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Pond2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,675.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(382,-151.25,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-3.55,-279.45,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-321,-142.85,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-210.85,167.25,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(221.95,335.35,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(209.8,-520.65,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel02();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond2, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Pond1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(153.2,490.45);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(335.5,329.55,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-146.6,138.55,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(160.6,13.05,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-286.35,-116.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(16.3,-311.7,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(271.2,-461.55,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.instance = new lib.BackgroundLevel01();
	this.instance.setTransform(-667.5,-1054.1,0.4322,0.4322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond1, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(317.2,598.05,2.3939,2.3939,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(5));

	// buttons
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-276.5,598.05,3,3,0,0,0,-41,0.1);

	this.nextButton = new lib.NextButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(236.25,598.05,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.prevButton}]}).wait(5));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-7.65,597.4,0.9,0.9,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(5));

	// Titles
	this.titleTextfield = new cjs.Text("xTitle", "20px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 25;
	this.titleTextfield.lineWidth = 314;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-727.45,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(5));

	// Text
	this.bodyTextfield = new cjs.Text("• xYou control the red racing car\nline2", "42px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 50;
	this.bodyTextfield.lineWidth = 852;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-425.5,-547.7011);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(5));

	// Line1
	this.lines1 = new lib.TutorialLines1();
	this.lines1.name = "lines1";
	this.lines1.setTransform(5.4,-616.3,1,1,0,0,0,0,-633.6);

	this.timeline.addTween(cjs.Tween.get(this.lines1).wait(5));

	// Line2
	this.lines2 = new lib.TutorialLines3();
	this.lines2.name = "lines2";
	this.lines2.setTransform(-260.8,-590);

	this.timeline.addTween(cjs.Tween.get(this.lines2).wait(5));

	// Line3
	this.lines3 = new lib.TutorialLines2();
	this.lines3.name = "lines3";
	this.lines3.setTransform(5.2,-609.1,1,1,0,0,0,-0.1,-603.1);

	this.timeline.addTween(cjs.Tween.get(this.lines3).wait(5));

	// Line4
	this.lines4 = new lib.TutorialLines4();
	this.lines4.name = "lines4";
	this.lines4.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines4).wait(5));

	// Line5
	this.lines5 = new lib.TutorialLines5();
	this.lines5.name = "lines5";
	this.lines5.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines5).wait(5));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(5));

	// bg2
	this.bg2 = new lib.TutorialBackground2();
	this.bg2.name = "bg2";
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(5));

	// bg3
	this.bg3 = new lib.TutorialBackgroundNext();
	this.bg3.name = "bg3";
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(5));

	// bg4
	this.bg4 = new lib.TutorialBackground4();
	this.bg4.name = "bg4";
	this.bg4.setTransform(816,1204,1,1,0,0,0,816,1204);
	this.bg4.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg4).wait(5));

	// bg5
	this.bg5 = new lib.TutorialBackgroundPractice();
	this.bg5.name = "bg5";
	this.bg5.setTransform(816,1204,1,1,0,0,0,816,1204);
	this.bg5.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg5).wait(5));

	// bottom
	this.bottom = new lib.EmptyHudBottom();
	this.bottom.name = "bottom";
	this.bottom.setTransform(-8.75,790.45,1,1,0,0,0,750,89.4);

	this.timeline.addTween(cjs.Tween.get(this.bottom).wait(5));

	// game1
	this.game1 = new lib.TutorialGameBackground1();
	this.game1.name = "game1";

	this.timeline.addTween(cjs.Tween.get(this.game1).wait(5));

	// game2
	this.game2 = new lib.TutorialGameBackground2();
	this.game2.name = "game2";

	this.timeline.addTween(cjs.Tween.get(this.game2).wait(5));

	// game3
	this.game3 = new lib.TutorialGameBackground3();
	this.game3.name = "game3";

	this.timeline.addTween(cjs.Tween.get(this.game3).wait(5));

	// game4
	this.game4 = new lib.TutorialGameBackground4();
	this.game4.name = "game4";

	this.timeline.addTween(cjs.Tween.get(this.game4).wait(5));

	// game5
	this.game5 = new lib.TutorialGameBackground5();
	this.game5.name = "game5";

	this.timeline.addTween(cjs.Tween.get(this.game5).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-781,-1310,1860.4,2797.3);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hud
	this.hudBottom = new lib.HudBottom();
	this.hudBottom.name = "hudBottom";
	this.hudBottom.setTransform(2.85,786.15,3,3);

	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(2.85,-782,3,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.hud},{t:this.hudBottom}]}).wait(1));

	// level
	this.level = new lib.LevelPlaceholder();
	this.level.name = "level";

	this.timeline.addTween(cjs.Tween.get(this.level).wait(1));

	// Background
	this.bg = new lib.Backgroundwhite();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-762.1,-1184.2,1841.5,2239.2), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// other elements
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(-1349.1,61.25,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// tutorial
	this.instance = new lib.TutorialOverlaySkin();
	this.instance.setTransform(3732.45,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance.cache(-783,-1312,1864,2801);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Level assets
	this.instance_1 = new lib.Fish7F();
	this.instance_1.setTransform(2975.5,-971.8,1,1,0,0,0,-0.2,-113.2);

	this.instance_2 = new lib.Fish7E();
	this.instance_2.setTransform(2975.5,-1247.1,1,1,0,0,0,-0.2,-113.2);

	this.instance_3 = new lib.Fish7D();
	this.instance_3.setTransform(2975.5,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_4 = new lib.Fish7C();
	this.instance_4.setTransform(2975.5,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_5 = new lib.Fish7B();
	this.instance_5.setTransform(2975.5,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_6 = new lib.Fish7A();
	this.instance_6.setTransform(2975.5,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_7 = new lib.Pond6();
	this.instance_7.setTransform(-2737.25,-4600.9,1,1,0,0,0,384.5,549.5);

	this.instance_8 = new lib.Pond5();
	this.instance_8.setTransform(-2737.25,-2552.75,1,1,0,0,0,384.5,549.5);

	this.instance_9 = new lib.Pond4();
	this.instance_9.setTransform(-2737.25,-504.6,1,1,0,0,0,384.5,549.5);

	this.instance_10 = new lib.Pond3();
	this.instance_10.setTransform(-2737.25,1543.55,1,1,0,0,0,384.5,549.5);

	this.instance_11 = new lib.Pond2();
	this.instance_11.setTransform(-2737.25,3591.7,1,1,0,0,0,384.5,549.5);

	this.instance_12 = new lib.Fish6F();
	this.instance_12.setTransform(2729.8,-971.8,1,1,0,0,0,-0.2,-113.2);

	this.instance_13 = new lib.Fish5F();
	this.instance_13.setTransform(2483.4,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_14 = new lib.Fish4F();
	this.instance_14.setTransform(2226.1,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_15 = new lib.Fish3F();
	this.instance_15.setTransform(1958,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_16 = new lib.Fish2F();
	this.instance_16.setTransform(1699.1,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_17 = new lib.Fish1F();
	this.instance_17.setTransform(1450.7,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_18 = new lib.Fish6E();
	this.instance_18.setTransform(2729.8,-1247.1,1,1,0,0,0,-0.2,-113.2);

	this.instance_19 = new lib.Fish6D();
	this.instance_19.setTransform(2729.8,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_20 = new lib.Fish6C();
	this.instance_20.setTransform(2729.8,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_21 = new lib.Fish6B();
	this.instance_21.setTransform(2729.8,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_22 = new lib.Fish6A();
	this.instance_22.setTransform(2729.8,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_23 = new lib.Fish5E();
	this.instance_23.setTransform(2483.4,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_24 = new lib.Fish5D();
	this.instance_24.setTransform(2475.3,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_25 = new lib.Fish5C();
	this.instance_25.setTransform(2475.3,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_26 = new lib.Fish5B();
	this.instance_26.setTransform(2483.4,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_27 = new lib.Fish5A();
	this.instance_27.setTransform(2483.4,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_28 = new lib.Fish4E();
	this.instance_28.setTransform(2226.1,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_29 = new lib.Fish4D();
	this.instance_29.setTransform(2226.1,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_30 = new lib.Fish4C();
	this.instance_30.setTransform(2226.1,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_31 = new lib.Fish4B();
	this.instance_31.setTransform(2226.1,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_32 = new lib.Fish4A();
	this.instance_32.setTransform(2226.1,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_33 = new lib.Fish3E();
	this.instance_33.setTransform(1958,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_34 = new lib.Fish3D();
	this.instance_34.setTransform(1958,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_35 = new lib.Fish3C();
	this.instance_35.setTransform(1958,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_36 = new lib.Fish3A();
	this.instance_36.setTransform(1958,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_37 = new lib.Fish3B();
	this.instance_37.setTransform(1958,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_38 = new lib.Fish2E();
	this.instance_38.setTransform(1699.1,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_39 = new lib.Fish2D();
	this.instance_39.setTransform(1699.1,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_40 = new lib.Fish2C();
	this.instance_40.setTransform(1699.1,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_41 = new lib.Fish2B();
	this.instance_41.setTransform(1699.1,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_42 = new lib.Fish2A();
	this.instance_42.setTransform(1699.1,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_43 = new lib.Fish1E();
	this.instance_43.setTransform(1450.7,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_44 = new lib.Fish1D();
	this.instance_44.setTransform(1450.7,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_45 = new lib.Fish1C();
	this.instance_45.setTransform(1450.7,-1776.5,1,1,0,0,0,-0.2,-113.2);

	this.instance_46 = new lib.Fish1B();
	this.instance_46.setTransform(1450.7,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_47 = new lib.Fish1A();
	this.instance_47.setTransform(1450.7,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_48 = new lib.PuddleButton();
	this.instance_48.setTransform(-441.25,839.55,1,1,0,0,0,57,39);

	this.instance_49 = new lib.Pond1();
	this.instance_49.setTransform(-2737.25,5639.85,1,1,0,0,0,384.5,549.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// level prepare
	this.instance_50 = new lib.LevelPrepareOverlaySkin();
	this.instance_50.setTransform(-807.35,424.95,1,1,0,0,0,537.5,733.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_50).wait(1));

	// gatekeeper
	this.instance_51 = new lib.GateKeeperOverlaySkin();
	this.instance_51.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_51.cache(-750,-1182,1835,2305);

	this.timeline.addTween(cjs.Tween.get(this.instance_51).wait(1));

	// endscreen
	this.instance_52 = new lib.EndScreenSkin();
	this.instance_52.setTransform(2067.75,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_52).wait(1));

	// gamescreen
	this.instance_53 = new lib.GameScreenSkin();
	this.instance_53.setTransform(540,986,1,1,0,0,0,0,115);

	this.timeline.addTween(cjs.Tween.get(this.instance_53).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-3249.2,-5333.5,7758.9,11417.9);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel01.png", id:"MainAssets_BackgroundLevel01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel02.png", id:"MainAssets_BackgroundLevel02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel03.png", id:"MainAssets_BackgroundLevel03", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel04.png", id:"MainAssets_BackgroundLevel04", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel05.png", id:"MainAssets_BackgroundLevel05", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevel06.png", id:"MainAssets_BackgroundLevel06", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackgroundLevelLonger.png", id:"MainAssets_BackgroundLevelLonger", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Buoy.png", id:"MainAssets_Buoy", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ClipboardIcon.png", id:"MainAssets_ClipboardIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_1.png", id:"MainAssets_Fish01_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_2.png", id:"MainAssets_Fish01_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_3.png", id:"MainAssets_Fish01_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_4.png", id:"MainAssets_Fish01_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_5.png", id:"MainAssets_Fish01_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_6.png", id:"MainAssets_Fish01_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish01_7.png", id:"MainAssets_Fish01_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_1.png", id:"MainAssets_Fish02_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_2.png", id:"MainAssets_Fish02_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_3.png", id:"MainAssets_Fish02_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_4.png", id:"MainAssets_Fish02_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_5.png", id:"MainAssets_Fish02_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_6.png", id:"MainAssets_Fish02_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish02_7.png", id:"MainAssets_Fish02_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_1.png", id:"MainAssets_Fish03_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_2.png", id:"MainAssets_Fish03_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_3.png", id:"MainAssets_Fish03_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_4.png", id:"MainAssets_Fish03_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_5.png", id:"MainAssets_Fish03_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_6.png", id:"MainAssets_Fish03_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish03_7.png", id:"MainAssets_Fish03_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_1.png", id:"MainAssets_Fish04_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_2.png", id:"MainAssets_Fish04_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_3.png", id:"MainAssets_Fish04_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_4.png", id:"MainAssets_Fish04_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_5.png", id:"MainAssets_Fish04_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_6.png", id:"MainAssets_Fish04_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish04_7.png", id:"MainAssets_Fish04_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_1.png", id:"MainAssets_Fish05_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_2.png", id:"MainAssets_Fish05_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_3.png", id:"MainAssets_Fish05_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_4.png", id:"MainAssets_Fish05_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_5.png", id:"MainAssets_Fish05_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_6.png", id:"MainAssets_Fish05_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish05_7.png", id:"MainAssets_Fish05_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_1.png", id:"MainAssets_Fish06_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_2.png", id:"MainAssets_Fish06_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_3.png", id:"MainAssets_Fish06_3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_4.png", id:"MainAssets_Fish06_4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_5.png", id:"MainAssets_Fish06_5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_6.png", id:"MainAssets_Fish06_6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish06_7.png", id:"MainAssets_Fish06_7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fishingspot_1.png", id:"MainAssets_Fishingspot_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotBubble.png", id:"MainAssets_FishingSpotBubble", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotDarker.png", id:"MainAssets_FishingSpotDarker", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotHighlight.png", id:"MainAssets_FishingSpotHighlight", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingspotPart01.png", id:"MainAssets_FishingspotPart01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotPart02.png", id:"MainAssets_FishingSpotPart02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotPart03.png", id:"MainAssets_FishingSpotPart03", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FishingSpotPart04.png", id:"MainAssets_FishingSpotPart04", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay1_Observe.png", id:"MainAssets_Overlay1_Observe", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay2_Fish.png", id:"MainAssets_Overlay2_Fish", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay3_Professor.png", id:"MainAssets_Overlay3_Professor", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay4_Report.png", id:"MainAssets_Overlay4_Report", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay5_Practice.png", id:"MainAssets_Overlay5_Practice", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopupBG.png", id:"MainAssets_PopupBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PracticeIndicatorBackground.png", id:"MainAssets_PracticeIndicatorBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProfCorrect.png", id:"MainAssets_ProfCorrect", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProfessorRod.png", id:"MainAssets_ProfessorRod", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProfIncorrect.png", id:"MainAssets_ProfIncorrect", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProfNeutral_Closed.png", id:"MainAssets_ProfNeutral_Closed", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/speech_balloon_triangle1.png", id:"MainAssets_speech_balloon_triangle1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Splashscreen.png", id:"MainAssets_Splashscreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Textballoon_Small1.png", id:"MainAssets_Textballoon_Small1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TopbarHUD.png", id:"MainAssets_TopbarHUD", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/UndoButton.png", id:"MainAssets_UndoButton", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;